/* Подписи интерфейса, английский. Правится руками.
 *
 * Учебный текст модулей лежит не здесь, а в content.<lang>.js. Оба правятся
 * руками. {в фигурных скобках} — подстановка, см. fill() в src/i18n.
 */

export const ui_en = {
  // общее, встречается на нескольких экранах
  'ui.common.loading': 'Loading...',
  'ui.common.continue': 'Continue',
  'ui.common.check': 'Check',
  'ui.common.seeResults': 'See my results',
  'ui.common.myProgress': 'My progress',
  'ui.common.startTraining': 'Start training',
  'ui.common.min': 'min',

  // инструктор
  'ui.alisa.name': 'Alisa',
  'ui.alisa.initial': 'A',

  // нижняя навигация
  'ui.nav.home': 'Home',
  'ui.nav.modules': 'Modules',
  'ui.nav.progress': 'Progress',
  'ui.nav.profile': 'Profile',

  // заставка и знакомство
  'ui.splash.tagline': 'Your first day on the road',
  'ui.splash.cardTitle': 'Interactive trainer',
  'ui.splash.cardText':
    'Train with Alisa, your virtual instructor. Practise real situations somewhere safe and get ready for your first day at work. It only takes about 5 minutes!',
  'ui.splash.start': 'Start',
  'ui.splash.imAlisa': 'I\'m Alisa',
  'ui.splash.yourName': 'What\'s your name?',
  'ui.splash.introducePrompt': 'Tell me your name and we can get started',
  'ui.splash.namePlaceholder': 'Enter your name',

  // главный экран
  'ui.home.badgeLine1': 'First day',
  'ui.home.badgeLine2': 'on the road',
  'ui.home.welcome': 'Welcome,',
  'ui.home.ctaContinue': 'Continue training',
  'ui.home.ctaRetake': 'Retake training',
  'ui.home.ctaStart': 'Start training',
  'ui.home.settings': 'Settings',
  'ui.home.modulesDone': '{done}/{total} modules done',

  // список модулей
  'ui.modules.title': 'Modules',
  'ui.modules.subtitle': 'Pick a topic to train on',

  // учебный материал
  'ui.learning.notFound': 'Learning material not found',
  'ui.learning.label': 'Learning material',
  'ui.learning.alisaHint': 'Read this before you take the test. Everything that matters is in here!',
  'ui.learning.contents': 'Contents',
  'ui.learning.doneTitle': 'All read!',
  'ui.learning.doneSubtitle': 'Now test what you know in the interactive quiz',
  'ui.learning.goToTest': 'Go to the test',
  'ui.learning.startTest': 'Start the test',

  // прохождение модуля
  'ui.module.title': 'Module 1: {title}',
  'ui.module.notFound': 'Module not found',
  'ui.module.leaveConfirm': 'Sure you want to leave? Your progress will be saved.',
  'ui.module.voiceOn': 'Voice on',
  'ui.module.voiceOff': 'Voice off',
  'ui.module.voiceUnavailable': 'Voice is not available in the demo',

  // результаты
  'ui.results.moduleComplete': 'Module "{title}" complete',
  'ui.results.statusExcellent': 'Excellent!',
  'ui.results.statusGood': 'Good!',
  'ui.results.statusFair': 'Fair',
  'ui.results.statusMoreTraining': 'More training needed',
  'ui.results.recPerfect':
    'You\'re well prepared for your first day! Every answer was correct. You\'re ready to hit the road!',
  'ui.results.recDecent': 'Decent result! Look at where you slipped up and try again to make it stick.',
  'ui.results.recRetake':
    'I\'d take the module again. Read each situation carefully and watch for the hints.',
  'ui.results.time': 'Time',
  'ui.results.mistakes': 'Mistakes',
  'ui.results.points': 'Points',
  'ui.results.breakdown': 'Points breakdown',
  'ui.results.advice': 'Alisa\'s advice',
  'ui.results.tryAgain': 'Try again',
  'ui.results.backToMenu': 'Back to menu',
  'ui.results.metric.Safety': 'Safety',
  'ui.results.metric.Service': 'Service',
  'ui.results.metric.Efficiency': 'Efficiency',
  'ui.results.metric.Professionalism': 'Professionalism',
  'ui.results.metric.StressResistance': 'Stress resistance',

  // прогресс
  'ui.progress.title': 'Progress',
  'ui.progress.subtitle': 'Your achievements and training history',
  'ui.progress.completed': 'Completed',
  'ui.progress.totalPoints': 'Total points',
  'ui.progress.overall': 'Overall progress',
  'ui.progress.history': 'Attempt history',
  'ui.progress.empty': 'You haven\'t completed a module yet',
  'ui.progress.unknownModule': 'Unknown module',
  'ui.progress.gradeGreat': 'Great',
  'ui.progress.gradeGood': 'Good',
  'ui.progress.gradeRetake': 'Retake',
  'ui.progress.pts': 'pts',

  // профиль
  'ui.profile.role': 'Trainee courier',
  'ui.profile.statModules': 'Modules',
  'ui.profile.statTime': 'Time',
  'ui.profile.statBest': 'Best',
  'ui.profile.logout': 'Log out',
  'ui.profile.logoutConfirm': 'Are you sure? All your progress will be deleted.',


  // ссылки наружу: сайт агентства и запись звонка
  'ui.cta.site': 'Built by BrilliantFlux',
  'ui.cta.booking': 'Book a call',

  // вкладка браузера
  'ui.meta.title': 'Delivery Ace | Training Simulator',
  'ui.meta.description': 'Interactive training simulator for delivery couriers',
};
